<template>
  <div
    class="loader"
    :class="{
      'loader--sm': props.size === 'sm',
      'loader--accent': props.variation === 'accent',
      'loader--white': props.variation === 'white',
    }"
  >
    <div class="loader--1"></div>
    <div class="loader--2"></div>
    <div class="loader--3"></div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  size?: "sm";
  variation?: "accent" | "white";
}>();
</script>
